import paredAnalytics from 'pared/analytics/utils/ParedAnalytics'

export const track = {
  async directorChanged(directorEmployeeId: number) {
    await paredAnalytics.track('Corporate Delivery - Director Change', {
      directorEmployeeId,
    })
  },
}
